module.exports = __webpack_public_path__ + "static/media/practice-question-divider.284f6065.png";